import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export const Header = () => {
  const { count, setOpen } = useCart();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const links = [
    { to: "/", label: "Home" },
    { to: "/shop", label: "Shop" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
    { to: "/reviews", label: "Reviews" },
  ];

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/5"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-6 md:px-12 h-16 flex items-center justify-between gap-2">
        <Link
          to="/"
          data-testid="logo-link"
          className="shrink-0 font-display text-lg sm:text-xl font-extrabold tracking-tighter text-zinc-900"
        >
          Vsense
          <span className="text-zinc-400">.</span>
        </Link>

        <nav className="flex flex-1 items-center justify-center gap-2.5 sm:gap-6 md:gap-10 min-w-0 overflow-x-auto no-scrollbar">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              onClick={(e) => {
                if (!l.to.includes("#")) {
                  e.preventDefault();
                  navigate(l.to);
                }
              }}
              className="whitespace-nowrap text-xs sm:text-sm text-zinc-600 hover:text-zinc-900 transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3 sm:gap-5 shrink-0">
          {user ? (
            <button
              data-testid="logout-btn"
              onClick={logout}
              className="text-[13px] sm:text-sm text-zinc-600 hover:text-zinc-900 transition-colors"
            >
              Sign out
            </button>
          ) : (
            <Link
              to="/auth"
              data-testid="header-account-link"
              className="flex items-center gap-2 text-[13px] sm:text-sm text-zinc-600 hover:text-zinc-900 transition-colors"
            >
              <User className="w-4 h-4" /> <span className="hidden sm:inline">Account</span>
            </Link>
          )}

          <button
            data-testid="open-cart-btn"
            onClick={() => setOpen(true)}
            className="relative p-1 text-zinc-800 hover:text-zinc-900 transition-colors"
          >
            <ShoppingBag className="w-5 h-5" />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-1.5 -right-1.5 bg-zinc-900 text-white text-[10px] font-semibold w-4 h-4 rounded-full flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};
